import { DateTime } from 'luxon';
import { KV, Entry, minutesToMillis } from '.';

export default class InMemoryKV implements KV {
    store: Map<string, Entry>;
    timeoutStore: Map<string, ReturnType<typeof setTimeout>>;
    DEFAULT_TTL = 10;
    constructor() {
        this.timeoutStore = new Map();
        this.store = new Map();
    }
    has(key: string): boolean {
        return this.store.has(key);
    }
    get(key: string, defaultValue?: unknown): unknown | null {
        const entry = this.store.get(key);
        if (!entry && defaultValue) {
            return defaultValue;
        }
        if (!entry) {
            return null;
        }
        return entry.value;
    }
    set(key: string, data: unknown, ttl?: number | null) {
        // Check if there is a key and if it's attached to a timeout
        // If it is, it clears that timeout so it can be overwriten
        if (this.store.has(key) && this.timeoutStore.has(key)) {
            const id = this.timeoutStore.get(key);
            clearTimeout(id);
        }
        if (ttl === null) {
            this.store.set(key, {
                value: data,
                ttl
            });
            return;
        }

        if (ttl === undefined) {
            ttl = minutesToMillis(this.DEFAULT_TTL)
        } else {
            ttl = minutesToMillis(ttl)
        }

        const ttlDT = DateTime.now().plus({ milliseconds: ttl });
        this.store.set(key, {
            value: data,
            ttl: ttlDT.toJSDate()
        });

        const timeoutId = setTimeout(() => {
            this.delete(key);
            if (this.timeoutStore.get(key)) {
                this.timeoutStore.delete(key);
            }
        }, ttl);
        this.timeoutStore.set(key, timeoutId);
    }
    delete(key: string) {
        if (this.has(key)) {
            this.store.delete(key);
            const id = this.timeoutStore.get(key);
            if (id) {
                clearTimeout(id);
            }
        }
    }
    clear() {
        this.store.clear();
        for (const [k] of this.timeoutStore) {
            const id = this.timeoutStore.get(k);
            if (id) {
                clearTimeout(id)
            }
        }
        this.timeoutStore.clear();
    }
}